import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    orderBy,
    limit, writeBatch
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addParentProducts,
    updateParentProducts,
    updateSingleParentProduct,
    batchUpdateParentProducts,
    deleteSingleParentProduct,
    getSingleParentProduct,
    getSingleParentProductById,
    searchParentProducts,
    getAllPODParentProducts,
    prepareParentProductsList
}

const collectionName = 'parent-products';
const collectionReference = collection(fireStoreDB, collectionName);

const addParentProducts = (parentProducts) => {
    return Promise.map(parentProducts, async parentProduct => {
        console.log('.');
        await addSingleParentProduct(parentProduct);
    });
}

const updateParentProducts = (parentProducts) => {
    const parentProductsBatchList = _.chunk(parentProducts, 100);

    return Promise.map(parentProductsBatchList, async parentProductsList => {
        console.log('.');
        const promises = [];
        let batch = writeBatch(fireStoreDB);

        _.forEach(parentProductsList, (parentProduct: any) => {
            const docRef = doc(collectionReference, parentProduct.id);
            batch.update(docRef, parentProduct, {merge: true});
        });

        promises.push(batch.commit());
        await Promise.all(promises);
    });
}

const batchUpdateParentProducts = async (parentProducts) => {
    let batch = writeBatch(fireStoreDB);
    const promises = [];
    const parentProductsBatchList = _.chunk(parentProducts, 100);

    _.forEach(parentProductsBatchList, (parentProducts) => {
        _.forEach(parentProducts, (parentProduct: any) => {
            const docRef = doc(collectionReference, parentProduct.id);
            batch.update(docRef, parentProduct, {merge: true});
        });

        promises.push(batch.commit());
        batch = writeBatch(fireStoreDB);
    });

    await Promise.all(promises);
    return;
};

const addSingleParentProduct = (parentProduct) => {
    return addDoc(collectionReference, parentProduct);
}

const updateSingleParentProduct = (parentProduct) => {
    const documentReference = doc(fireStoreDB, collectionName, parentProduct.id);
    return setDoc(documentReference, parentProduct);
}

const deleteSingleParentProduct = (parentProduct) => {
    const documentReference = doc(fireStoreDB, collectionName, parentProduct.id);
    return deleteDoc(documentReference);
}

const getSingleParentProduct = (parentProductId) => {
    const documentReference = doc(fireStoreDB, collectionName, parentProductId);
    return getDoc(documentReference);
}

const getSingleParentProductById = async (parentProductId) => {
    const documentReference = doc(fireStoreDB, collectionName, parentProductId);
    const parentProductDoc = await getDoc(documentReference);

    return prepareSingleParentProduct(parentProductDoc);
}

const searchParentProducts = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });


    /*searchQuery = query(searchQuery,
        limit(20));*/

    const parentProductResult = await getDocs(searchQuery);
    return prepareParentProductsList(parentProductResult);
}

const getAllPODParentProducts = async (podId) => {
    let searchQuery = query(collectionReference,
        where("podId", "==", podId));

    const parentProductResult = await getDocs(searchQuery);
    return prepareParentProductsList(parentProductResult);
}

const prepareParentProductsList = (parentProductResult) => {
    const parentProductsList = [];

    _.forEach(parentProductResult.docs, parentProductDoc => {
        parentProductsList.push({
            ...parentProductDoc.data(),
            id: parentProductDoc.id
        });
    });

    return parentProductsList;
}


const prepareSingleParentProduct = (parentProductDoc) => {
    const parentProduct = parentProductDoc.data();
    parentProduct.id = parentProductDoc.id;
    return parentProduct;
}
